import React from 'react';
import cn from 'classnames';
import Head from 'next/head';
import Instructions from './Instructions';
import StakeholderBenefits from './StakeholderBenefits';
import Awards from '../Awards';
import LearnMore from '../LearnMore';
import FooterPattern from '@/Framework/UI/Pages/Landing/Sections/FooterPattern';
import titlePattern from '../assets/titlePattern.svg';

import baseStyles from '../tenantInvestorSet.scss';
import styles from './howItWorks.scss';

const HowItWorks = () => (
  <>
    <Head>
      <title>Overview & How It Works | InvestorSet</title>
      <meta
        name="description"
        content="Access final documentation in minutes, not days."
      />
    </Head>
    <div className={ cn(baseStyles.intro, styles.intro) }>
      <h1 className={ cn(baseStyles.sectionTitle, baseStyles.title) }>
        How InvestorSet works
      </h1>
      <div className={ baseStyles.titlePattern }>
        <img src={ titlePattern } />
      </div>
    </div>
    <div className={ styles.howItWorksContentContainer }>
      <Instructions />
    </div>
    <StakeholderBenefits />
    <Awards className={ styles.awardsWrp } />
    <LearnMore />
    <FooterPattern />
  </>
);

export default HowItWorks;
